import { AnimatedCarouselComponentWidget } from "@/features/carousel/animated-showcase";
import Widget from "@/components/widgets";
import type { WidgetConfig } from "@/types";

declare global {
  interface Window {
    AnimatedCarouselWidget: typeof AnimatedCarouselWidget;
  }
}

class AnimatedCarouselWidget extends Widget {
  static init(config: WidgetConfig) {
    return super.init(config, AnimatedCarouselComponentWidget);
  }
}

if (typeof window !== "undefined") {
  window.AnimatedCarouselWidget = AnimatedCarouselWidget;
}

export default AnimatedCarouselWidget;
